"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.generateCommonErrorMetadata = void 0;
var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));
/* eslint-disable import/prefer-default-export */
/**
 * Generates common metadata for errors
 * @param {any} error
 * @returns {object}
 */
var generateCommonErrorMetadata = exports.generateCommonErrorMetadata = function generateCommonErrorMetadata(error) {
  if (error instanceof Error) {
    return (0, _stringify.default)({
      message: error === null || error === void 0 ? void 0 : error.message,
      name: error === null || error === void 0 ? void 0 : error.name,
      stack: error === null || error === void 0 ? void 0 : error.stack
    });
  }
  return error;
};
//# sourceMappingURL=utils.js.map
